import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FC } from 'react';
import type { Category } from '@features/categories/types';
import type { Property } from 'shared-types/Property';

import { SpaDaysCategoryContainer } from './container';
import { SpaDaysCategoryV2 } from './v2';

type SpaDaysCategoryVersionProps = {
  property: Property;
  language: string;
  category: Category;
};

export const SpaDaysCategoryVersion: FC<SpaDaysCategoryVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2.spa-days');
  if (isV2) return <SpaDaysCategoryV2 category={props.category} language={props.language} />;
  return (
    <SpaDaysCategoryContainer
      property={props.property}
      language={props.language}
      category={props.category}
    />
  );
};
